<template>
  <footer>
    <slot></slot>
  </footer>
</template>

<script>
export default {
  name: "amFooter"
};
</script>

<style lang="scss" scoped>
</style>
